var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-o-section-ratings"},[_c('h2',{staticClass:"c-o-section-ratings__title"},[_vm._v(" "+_vm._s(_vm.headline))]),_vm._v(" "),_c('div',{staticClass:"c-o-section-ratings__content"},_vm._l((_vm.ratings),function(item,key){return _c('latest-rating-molecule',{key:key,staticClass:"c-o-section-ratings__rating",attrs:{"rating":item}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6502d851","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/organisms/page-sections/OrganismSectionRatings.vue
// module id = 1144
// module chunks = 0